import { Fragment } from "react";
import { Dialog, DialogPanel, Transition } from "@headlessui/react";
import { Dibpos } from "../../../images";
import classNames from "../../../utils/classNames";
import CloseIcon from "../../../assets/cross.svg";

type Props = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  children: React.ReactNode;
  title: string;
  size?: any;
};

export default function Modal(props: Props) {
  const { isOpen, setIsOpen, children, title, size = "max-w-xl" } = props;
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <div className="fixed inset-0 bg-black bg-opacity-25" />
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <DialogPanel
              className={classNames(
                `${size} w-full  transform overflow-hidden rounded bg-white text-left align-middle shadow-xl transition-all`
              )}
            >
              <div className="flex justify-between w-full bg-primary items-center px-3 py-1">
                <img src={Dibpos} className="w-7 h-7 cursor-pointer" />
                <span className="text-[18px] text-white font-bold">
                  {title}
                </span>
                <span className="cursor-pointer" onClick={closeModal}>
                  <img src={CloseIcon} alt={CloseIcon} />
                </span>
              </div>
              <div className="p-2 ">{children}</div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
